<ckeditor
  [editor]="Editor"
  [(ngModel)]="value"
  [config]="config"
  (ngModelChange)="onChange()"
></ckeditor>
